<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full-screen"
      :no-padding="true">
    <template #header>
      <span>添加采购计划</span>
    </template>
    <template #content>
      <app-base-main>
        <template #base-content>
          <div class="content-cell">
            <template>
              <el-form
                  ref="form" :model="form" label-width="100px">
                <el-form-item
                    label="备注："
                    prop="memo">
                  <gj-input
                      v-model="form.memo"
                      maxlength="200"
                      width="50%">
                  </gj-input>
                </el-form-item>
                <el-form-item
                    label="附件："
                    prop="desc">
                  <gj-upload
                      upload-btn-type="default"
                      :container-biz-id="transferOrder ? transferOrder.id : null"
                      container-type="PURCHASE_PLAN"
                      :valid-file-size="10"
                      :beforeUpload="handleExceed"
                      :text="'上传'"
                      :acceptType="[]"
                      :fileList.sync="form.files"
                      specialUpload
                  ></gj-upload>
                </el-form-item>
              </el-form>
            </template>
            <app-op-purchase-plan-product
                style="margin-top: 24px"
                ref="productForm"
                :form="form"
                :offsetHeight="appendHeight"
                :lengthTitle="lengthTitle"
                :cloneDeliveryPlan="cloneDeliveryPlan"
                :op-type="opType"
                :transfer-order="transferOrder"
                :mount-to="$mountTo"
            ></app-op-purchase-plan-product>
            <div style="text-align: center;margin-top: 15px">
              <gj-button @click="goBack">取消</gj-button>
              <gj-button v-if="addOpType && draftVisible" :loading="loading.saveAsDraft"
                         @click="saveOrAudit(true)">保存为草稿
              </gj-button>
              <gj-button :loading="loading.audit"
                         type="primary" @click="saveOrAudit(false)">确定
              </gj-button>
            </div>
          </div>
        </template>
      </app-base-main>
    </template>
  </gj-modal>


</template>

<script>
import {formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin, modalMixIn} from "@/minxins";
import {OpEnum} from "@/utils/options";
import AppOpPurchasePlanProduct from "./product/op-purchase-plan-product";
import {addPurchasePlan, editPurchasePlan, purchasePlanAddArraignment, queryReviewSetting} from "@/api/purchase";
import {convertToFullDate} from "@/utils/date.util";
import {PurchasePlanEnum} from "../enum.js";
import {downloadAttFile} from "@/api/common";

export default {
  name: "app-op-purchase-plan-add-for-delivery",
  components: {AppOpPurchasePlanProduct},
  mixins: [formRuleMixin, responseMixin, opTypeMixin, valueCheckMixin, modalMixIn],
  props: {
    opType: {
      required: true
    },
    rows: {
      required: false,
      default: () => {
        return [];
      }
    },
    deliveryList: {
      required: false
    },
    delivery: {
      required: false,
      default: false,
    },
    type: {
      required: false,
      default: 'one'
    },
    appendHeight: {
      default: 80
    }
  },
  data() {
    return {
      data: {},
      form: {
        id: null,
        memo: null,
        files: [],
        items: []
      },
      lengthTitle: '产品种类',
      loading: {
        content: false,
        saveAsDraft: false,
        audit: false,
        finishPick: false,
      },
      OpEnum: OpEnum,
      PurchasePlanEnum: PurchasePlanEnum,
      transferOrder: {},
      draftVisible: false,
      cloneDeliveryPlan: [],
      breadcrumbList: [
        {
          name: '采购计划', handle: () => {
            this.goBack()
          }
        },
        {
          name: '添加', handle: () => {
          }
        }
      ]
    }
  },
  created() {
    if (this.editOpType) {
      if (this.rows.length > 0) {
        this.form.items = this._.cloneDeep(this.rows);
        this.form.items.forEach(item => {
          item.name = item.productName;
          item.deliveryWarehouse = item.deliveryWarehouseId;
        })
      }
    } else {
      if (this.delivery) {
        this.queryDelivery(this.deliveryList);
        this.lengthTitle = "商品总数";
      }
      this.queryReviewShow();
    }
  },
  computed: {},
  methods: {
    queryDelivery(res) {
      this.form.items = this._.cloneDeep(res);
      this.form.items.forEach(item => {
        item.name = item.productName;
        item.smallImageUrl = item.imageUrl;
        if (item.warehouseId) {
          this.$set(item, 'deliveryWarehouse', item.warehouseId)
        } else {
          this.$set(item, 'deliveryWarehouse', '')
        }
        this.$set(item, 'planQuantity',item.shipPlanQuantity)
        this.$set(item, 'memo',item.memo)
      })
    },
    handleExceed() {
      if (this.form.files.length >= 5) {
        this.$gjMessage.error("上传失败，失败原因：附件不超过10M，最大支持上传5个附件")
        return false;
      }
      return true;
    },
    queryReviewShow() {
      queryReviewSetting({name: 'PURCHASE_PLAN_REVIEW_SETTING'}).then(res => {
        this.draftVisible = res;
      })
    },
    download(fileId) {
      downloadAttFile(fileId);
    },
    saveOrAudit(saveDraft) {
      if (this.formValidate() && this.checkDeliveryWarehouse()) {
        if (saveDraft) {   //  保存为草稿
          this.loading.saveAsDraft = true;
        } else {
          this.loading.audit = true;
        }
        Promise.resolve(this.mapToFormParams())
            .then((params) => {
              if (this.addOpType) {
                if (saveDraft) {
                  return addPurchasePlan(params);
                } else {
                  return purchasePlanAddArraignment(params)
                }
              }
              if (this.editOpType) {
                return editPurchasePlan(params);
              }
            })
            .then(res => {
              this.$gjResponseHandle(res, () => {
                if (this.addOpType) {
                  this.$gjMessage.success(`操作成功!`);
                }
                if (this.editOpType) {
                  this.$gjMessage.success('操作成功!');
                }
                this.goBack('refresh');
              });
            })
            .complete(() => {
              if (saveDraft) {
                this.loading.saveAsDraft = false;
              } else {
                this.loading.audit = false;
              }
            });
      }
    },
    // 需要增加 聚焦事件
    checkDeliveryWarehouse() {
      for (let i = 0; i < this.form.items.length; i++) {
        if (!this.form.items[i].deliveryWarehouse) {
          this.$gjMessage.error(`目的仓库不能为空！`)
          return false;
        }
      }
      return true
    },
    goBack(val) {
      this.$emit('closeOpen', val);
    },
    mapToFormParams() {
      if (this.addOpType) {
        return {
          memo: this.form.memo,
          fileIdList: this.form.files.map(item => item.attId),
          planProducts: this.form.items.map(item => ({
            arrivalWarehouseId: item.deliveryWarehouse,
            memo: item.memo,
            planDeliveryDate: item.planDeliveryDate ? convertToFullDate(item.planDeliveryDate, 'yyyy-MM-dd') : null,
            planQuantity: item.planQuantity,
            singleQuantity: item.singleQuantity,
            shipPlanCodeList: item.shipPlanCodeList || [],
            sku: item.sku,
            urgent: item.urgent ? 1 : 0
          }))
        }
      }
      if (this.editOpType) {
        return [
          ...this.form.items.map(item => ({
            id: item.id || item.purchasePlanId,
            arrivalWarehouseId: item.deliveryWarehouse,
            memo: item.memo,
            planDeliveryDate: item.planDeliveryDate ? convertToFullDate(item.planDeliveryDate, 'yyyy-MM-dd') : null,
            planQuantity: item.planQuantity,
            singleQuantity: item.singleQuantity,
            sku: item.sku,
            urgent: item.urgent ? 1 : 0
          }))
        ]
      }
    },

    formValidate() {
      if (this.addOpType) {
        if (!this.$gjFormValidate()) {
          return false;
        }
      }
      if (!this.form.items || this.form.items.length === 0) {
        this.$gjMessage.error("没有可以提交的数据！")
        return false;
      }
      return this.$refs['productForm'].formValidate();
    }
  }
}
</script>

<style scoped lang="scss">
.nav-tips {
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  font-weight: 400;
}

.tips-to {
  color: #333333;
}

.content-cell {
  background: #fff;
  padding: 0 15px;
}

.header {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  font-weight: 600;
  // padding-bottom: 15px;
}

.base-text {
  color: #999999;
  font-size: 12px;
}

.icon-back {
  color: #999999;
  font-size: 12px;
  cursor: pointer;
}

.icon-back:hover {
  color: #5d9bfc;
}

/deep/ .el-form {
  margin-top: 16px !important;
}
</style>

